export default {
    data: "Bearer eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50SWQiOiIxIiwicm9sZXMiOltdLCJleHAiOjE1NzIwNjgwNTh9.UT82tqeyKD_DHT2JhNN8TI_DwHpEmcfmQ5ttwB7WgyV7Pru_M2_o_quAUFHpn2ygRow01UgFZ502dyOvdEBAiw"
}



// WEBPACK FOOTER //
// ./src/configure/http/mock/response/login/index.js